import vfWebView from '@vodafonetr/vf-webview-ts';
import { webCookie } from './webCookie';

const init = (): Promise<void> => {
  return new Promise((resolve) => {
    if (window.utag === undefined) {
      window.utag_cfg_ovrd = { noview: true };
      window.utag_data = {};
      window.targetGlobalSettings = { bodyHidingEnabled: false };

      const d = document;
      let s: any;
      let s2: any;
      let t: any;

      s = d.createElement('script');
      s.language = 'javascript';
      s.type = 'text/javascript';
      s.async = 1;
      s.charset = 'utf-8';
      s.src = `https://tags.tiqcdn.com/utag/vodafone/${
        isWebViewClient() ? 'tr-myvfapp' : 'tr-main'
      }/${process.env.NEXT_PUBLIC_TEALIUM_ENVIRONMENT}/utag.js`;
      s2 = d.createElement('script');
      s2.language = 'javascript';
      s2.type = 'text/javascript';
      s2.async = 1;
      s2.charset = 'utf-8';
      s2.src = `https://tags.tiqcdn.com/utag/vodafone/${
        isWebViewClient() ? 'tr-myvfapp' : 'tr-main'
      }/${process.env.NEXT_PUBLIC_TEALIUM_ENVIRONMENT}/utag.sync.js`;
      t = d.getElementsByTagName('script')[0];
      t.parentNode.insertBefore(s, t);
      s.parentNode.insertBefore(s2, s);

      s.addEventListener(
        'load',
        () => {
          resolve();
        },
        false
      );
    } else {
      resolve();
    }
  });
};

interface SendReportProps {
  pageName: string;
  pageListingCategory?: string;
  pageType?: string;
  channel?: string;
  errorCode?: string;
  errorMessage?: string;
  errorType?: string;
  serviceName?: string;
  isLink?: boolean;
  extra?: object | null;
  event_name?: string;
  mbox?: { [key: string]: string } | null;
  c2dfixedAutologinOffer?: string;
  c2dfixedAutologin?: string;
  link_tracking?: any;
}

type Data = { [key: string]: string };

export const sendReport = ({
  pageName,
  pageType,
  pageListingCategory,
  channel,
  errorCode = '',
  errorMessage = '',
  errorType = '',
  serviceName = '',
  event_name = '',
  isLink = false,
  extra = null,
  mbox = null,
  c2dfixedAutologinOffer = '',
  c2dfixedAutologin = '',
  link_tracking = '',
}: SendReportProps) => {
  init().then(() => {
    let data: Data = {
      page_name: (isWebViewClient() ? `vfy` : `bireysel`) + pageName,
    };

    if (pageListingCategory) {
      data['page_listing_category'] = pageListingCategory;
    }
    if (pageType) {
      data['page_type'] = pageType;
    }

    if (channel) {
      data['channel'] = channel;
    }

    if (errorMessage && errorCode && serviceName) {
      data['error_message'] = errorMessage;
      data['error_id'] = errorCode;
      data['api_method'] = serviceName;
    }

    if (event_name) {
      data['event_name'] = event_name;
    }
    if (sessionStorage.getItem('link_tracking')) {
      link_tracking = sessionStorage.getItem('link_tracking');
      data['link_tracking'] = link_tracking;
      sessionStorage.setItem('link_tracking', '');
    }

    if (c2dfixedAutologinOffer) {
      data['c2dfixed_autologin_offer'] = c2dfixedAutologinOffer;
    }

    if (c2dfixedAutologin) {
      data['c2dfixed_autologin'] = c2dfixedAutologin;
    }
    if (extra) {
      data = { ...data, ...extra };
    }
    //TODO:
    //console.table(data);

    if (isLink) {
      window.utag.link(clearData(data));
    } else {
      window.utag.view(clearData(data));
    }

    sent2GTM();

    const mboxData = [];
    if (mbox) {
      for (const key of Object.keys(mbox)) {
        mboxData.push(key + '=' + mbox[key]);
      }
    }
    mBoxUpdate(mboxData);
  });
};

const sent2GTM = () => {
  const { dataLayer, utag_data, sent2GTMRetry } = window as any;
  if (dataLayer && +sent2GTMRetry < 10) {
    dataLayer.push(utag_data);
    dataLayer.push({ event: 'gtm_event' });
  } else {
    setTimeout(sent2GTM, 500);
    window.sent2GTMRetry = sent2GTMRetry ? sent2GTMRetry + 1 : 1;
  }
};

const clearData = (data: Data) => {
  const prevItems = JSON.parse(
    sessionStorage.getItem('last-added-utag-items') || '[]'
  );

  prevItems.forEach((key: string) => {
    if (window.utag_data && window.utag_data[key]) {
      delete window.utag_data[key];
    }
  });

  sessionStorage.setItem(
    'last-added-utag-items',
    JSON.stringify(Object.keys(data))
  );
  return data;
};

const mBoxUpdate = (datas: string[]) => {
  const { mBoxUpdateCalled } = window as any;
  if (!mBoxUpdateCalled) {
    setTimeout((<any>window).callMboxUpdate, 1000);
    window.mBoxUpdateCalled = true;
  } else {
    const params: { [key: string]: string } = {};
    datas.forEach((item) => {
      const sp = item.split('=');
      params[sp[0]] = sp[1];
    });

    if (window.adobe) {
      window.adobe?.target?.trackEvent({ params });
    }
  }
};

// export const isWebViewClient = () => {
//   return !!window?.clientVariables?.sid;
// };
// vfWebView.getAllClientData();
export const isWebViewClient = () => {
  webCookie.get('platformName');
  return !!webCookie.get('platformName');
};
